import { yupLocalized } from "@ryde/shared";

export const viewEditValidation = {
  name: yupLocalized.string().required(),
  scope: yupLocalized.string().required(),
};
